import { useApp } from '@tldraw/editor'
import classNames from 'classnames'
import { track } from 'signia-react'
import { useBreakpoint, useTranslation } from '../../hooks'
import { Button } from '../primitives'

interface ToggleToolLockedButtonProps {
	activeToolId?: string
}

export const ToggleToolLockedButton = track(function ToolLockButton({
	activeToolId,
}: ToggleToolLockedButtonProps) {
	const app = useApp()
	const breakpoint = useBreakpoint()
	const msg = useTranslation()
	const {
		instanceState: { isToolLocked },
	} = app

	const isLockable = !(
		activeToolId === 'select' ||
		activeToolId === 'hand' ||
		activeToolId === 'draw' ||
		activeToolId === 'eraser' ||
		activeToolId === 'text'
	)

	if (!isLockable) return null

	return (
		<Button
			title={msg('action.toggle-tool-lock')}
			className={classNames('tlui-toolbar__lock-button', {
				'tlui-toolbar__lock-button__mobile': breakpoint < 5,
			})}
			icon={app.instanceState.isToolLocked ? 'lock' : 'unlock'}
			onClick={() => app.updateInstanceState({ isToolLocked: !isToolLocked })}
			smallIcon
		/>
	)
})
